// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2QJhG","validationTips":"StatementDescriptor_validationTips__2RvbF"};